/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OfertaEmpleoRangoGet$Params {
  skip?: number;
  quantity?: number;
}

export function ofertaEmpleoRangoGet(http: HttpClient, rootUrl: string, params?: OfertaEmpleoRangoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, ofertaEmpleoRangoGet.PATH, 'get');
  if (params) {
    rb.query('skip', params.skip, {});
    rb.query('quantity', params.quantity, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

ofertaEmpleoRangoGet.PATH = '/oferta-empleo/rango';
